import type { Numeric } from 'decimal.js-light';

// eslint-disable-next-line require-unicode-regexp
const nonDecimalChars = /[^-.0-9]/g;

/**
 * decimal.js is very unforgiving with what values it accepts.
 * This function will remove non-decimal characters to make it
 * easier to work with.
 */
export function cleanRawDecimalValue(rawValue: unknown): Numeric {
	if (typeof rawValue === 'string') {
		return rawValue.replaceAll(nonDecimalChars, '');
	}
	if (typeof rawValue === 'number') {
		return rawValue;
	}
	// If it's another type, let Decimal throw the error
	return rawValue as Numeric;
}
